import { render, staticRenderFns } from "./ExtraDataMatch.vue?vue&type=template&id=17ba94a6&"
import script from "./ExtraDataMatch.vue?vue&type=script&lang=js&"
export * from "./ExtraDataMatch.vue?vue&type=script&lang=js&"
import style0 from "./ExtraDataMatch.vue?vue&type=style&index=0&id=17ba94a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports